import React, {Component} from 'react';
import {
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    FlatList,
    I18nManager,
    Image,
    BackHandler,
    Alert,
    Platform,
    KeyboardAvoidingView
} from 'react-native';
import {moderateScale} from "../../../../../tools/Scaling";
import Colors from "../../../../../tools/Colors";
import HMTextView from "../../../../../customviews/HMTextView";
import i18n from "../../../../../I18n/i18n";
import store from "../../../../../redux/store";
import HMTextInput from "../../../../../customviews/HMTextInput";
import * as NavigationService from "../../../../../redux/NavigationService";
import {typeExport} from "../../../../../redux/store/type";

import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import HMActionBar from "../../../../../customviews/HMActionBar";
import HMItemCategory from "../../../../../customviews/HMItemCategory";
import Steps from "../../../../../customviews/steps/Steps";
import HMAlert from "../../../../../customviews/HMAlert";
import PathFile from "../../../../../assets/PathFile";

const PAGES = ['Page 1', 'Page 2', 'Page 3', 'Page 4', 'Page 5'];

const firstIndicatorConfigs = {
    stepIndicatorSize: 30,
    currentStepIndicatorSize: 40,
    separatorStrokeWidth: 3,
    currentStepStrokeWidth: 5,
    separatorFinishedColor: '#4aae4f',
    separatorUnFinishedColor: '#a4d4a5',
    stepIndicatorFinishedColor: '#4aae4f',
    stepIndicatorUnFinishedColor: '#a4d4a5',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 15,
    currentStepIndicatorLabelFontSize: 15,
    stepIndicatorLabelCurrentColor: '#000000',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: 'rgba(255,255,255,0.5)',
    labelColor: '#666666',
    labelSize: 12,
    currentStepLabelColor: '#4aae4f',
};

const secondIndicatorConfigs = {
    stepIndicatorSize: 30,
    currentStepIndicatorSize: 30,
    separatorStrokeWidth: 2,
    currentStepStrokeWidth: 3,
    stepStrokeCurrentColor: '#fe7013',
    stepStrokeWidth: 3,
    separatorStrokeFinishedWidth: 4,
    stepStrokeFinishedColor: '#fe7013',
    stepStrokeUnFinishedColor: '#aaaaaa',
    separatorFinishedColor: '#fe7013',
    separatorUnFinishedColor: '#aaaaaa',
    stepIndicatorFinishedColor: '#fe7013',
    stepIndicatorUnFinishedColor: '#ffffff',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 13,
    currentStepIndicatorLabelFontSize: 13,
    stepIndicatorLabelCurrentColor: '#fe7013',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: '#aaaaaa',
    labelColor: '#999999',
    labelSize: 13,
    currentStepLabelColor: '#fe7013',
};

const thirdIndicatorConfigs = {
    stepIndicatorSize: 25,
    currentStepIndicatorSize: 30,
    separatorStrokeWidth: 2,
    currentStepStrokeWidth: 3,
    stepStrokeCurrentColor: '#7eaec4',
    stepStrokeWidth: 3,
    stepStrokeFinishedColor: '#7eaec4',
    stepStrokeUnFinishedColor: '#dedede',
    separatorFinishedColor: '#7eaec4',
    separatorUnFinishedColor: '#dedede',
    stepIndicatorFinishedColor: '#7eaec4',
    stepIndicatorUnFinishedColor: '#ffffff',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 0,
    currentStepIndicatorLabelFontSize: 0,
    stepIndicatorLabelCurrentColor: 'transparent',
    stepIndicatorLabelFinishedColor: 'transparent',
    stepIndicatorLabelUnFinishedColor: 'transparent',
    labelColor: '#999999',
    labelSize: 13,
    currentStepLabelColor: '#7eaec4'
};
let stringListName = '';
let container = null;

const getStepIndicatorIconConfig = ({position, stepStatus}) => {
    const iconConfig = {
        name: 'feed',
        color: stepStatus === 'finished' ? '#ffffff' : '#fe7013',
        size: 15
    };
    switch (position) {
        case 0: {
            iconConfig.name = 'shopping-cart';
            break
        }
        case 1: {
            iconConfig.name = 'location-on';
            break
        }
        case 2: {
            iconConfig.name = 'assessment';
            break
        }
        case 3: {
            iconConfig.name = 'payment';
            break
        }
        case 4: {
            iconConfig.name = 'track-changes';
            break
        }
        default: {
            break
        }
    }
    return iconConfig
};
export default class SubmitSendOperationScreen extends Component {
    constructor(props) {
        super(props);
        container = this;
        //let listMenus=  store.getState().reducerSplashGetAllData.resultsSaina.result.list.find(({type}) => type == this.props.route.params.item.type).subjects;
        let listMenus = props.route.params.listExtra;
        //   let listPlace = store.getState().reducerSplashGetAllData.resultsSaina.result.places;
        this.state = {
            currentPage: 0,

            indexSelectedArray1: -1,
            itemSelectedArray1: null,

            itemSelectedArray1Sub: null,
            indexSelectedArray1Sub: -1,

            indexSelectedArray2: -1,
            itemSelectedArray2: null,


            indexSelectedArray2Sub: -1,
            itemSelectedArray2Sub: null,


            pageDataArray1Sub: [],
            pageDataArray2: [],
            pageDataArray2Sub: [],
            typeButton: "next",
            name: '',
            description: '',
            arrData: [],
            listName: [],

            checkedIcon: false,
            checkedStatus: false,


        }

        //this.pageDataArray = ['گروه موضوع', 'زیر گروه', 'منطقه', 'نوع منطقه', 'درج توضیحات'];
        this.pageDataArray = ['', '', '', '', ''];

        this.pageDataArray1 = listMenus

        //  this.pageDataArray2 = listPlace


    }

    componentDidMount() {
        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {
        if (this.state.currentPage >= 1) {
            this.setState({currentPage: this.state.currentPage - 1, typeButton: "back"}
                , () => {

                }
            )
        } else {
            NavigationService.Pop();
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (nextState.currentPage !== this.state.currentPage) {
            if (this.viewPager) {
                this.viewPager.setPage(nextState.currentPage)
            }
        }
    }

    async setData() {
        let {token} = store.getState().reducerSplashGetAllData
        let {itemExtra} = this.props.route.params;

        if (store.getState().reducerSplashGetAllData.Connection) {
            let {checkedIcon, checkedStatus} = this.state;
            let paramss = {
                "_operation": typeExport._Shahrdar,
                "mode": "SaveRefer",
                "lang": i18n.locale,
                "_session": token,
                "type": itemExtra.type,
                "description": this.state.description,

                "record": itemExtra.messageid,
                "chkChangeIcon": checkedIcon,
                "chkStateNew": checkedStatus,
                "priority": this.state.itemSelectedArray1 == null ? null : this.state.itemSelectedArray1.id,
                "unit": this.state.itemSelectedArray2Sub == null ?
                    (
                        this.state.itemSelectedArray2 == null ? (this.state.itemSelectedArray1Sub == null ? null : this.state.itemSelectedArray1Sub.id) : this.state.itemSelectedArray2.id
                    )
                    :
                    this.state.itemSelectedArray2Sub.id


            };

            this.props.callService(
                typeExport.urlSetSubmitSendOperationScreen,
                paramss,
                typeExport.TypeSetSubmitSendOperationScreen,
                "POST",
                token
            );
            //this.GoScreen()


        } else {


            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.errorNetwork'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                            //    NavigationService.navigatereset("ApplyScreen", {item: item})
                        }
                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                        , style: 'cancel'
                    },

                ],
                {cancelable: true}
            )


        }


    }


    handleScroll(event) {
    }

    render() {
        let textButtonNext = this.state.currentPage === 4 ? i18n.t('constant.Registration') : i18n.t('constant.next')
        let {listExtra} = this.props.route.params

        return (
            <View style={styles.container}>
                <HMActionBar menu
                             props={this.props} statusBarTransparent
                    // text={i18n.t('Privatizations.title')}
                             text={"ارسال"}
                             headerVisibility
                             more_menu
                             back
                             onBackPress={() => this.props.navigation.pop()}

                />
                <View style={styles.stepIndicator}>
                    <Steps
                        configs={firstIndicatorConfigs}
                        current={this.state.currentPage}
                        // reversed={true}
                        // labels={this.pageDataArray}
                    />
                </View>
                {/*     <View style={styles.stepIndicator}>
                    <Steps
                        renderStepIndicator={this.renderStepIndicator}
                        configs={secondIndicatorConfigs}
                        current={this.state.currentPage}
                        labels={[
                            'Cart',
                            'Delivery Address',
                            'Order Summary',
                            'Payment Method',
                            'Track'
                        ]}
                    />
                </View>
                <View style={styles.stepIndicator}>
                    <Steps
                        count={4}
                        configs={thirdIndicatorConfigs}
                        current={this.state.currentPage}
                        labels={['Approval', 'Processing', 'Shipping', 'Delivery']}
                    />
                </View>*/}
                {/*                <ViewPager
                    style={{flexGrow: 1,flexDirection: 'row-reverse'}}
                    ref={viewPager => {
                        this.viewPager = viewPager
                    }}
                    onPageSelected={page => {
                        this.setState({currentPage: page.position})
                    }}
                >
                    {PAGES.map((page, index) => this.renderViewPagerPage(page, index))}
                </ViewPager>*/}

                {/*         <ViewPager
                    ref={viewPager => {
                        this.viewPager = viewPager
                    }}
                    style={{flex: 1}}
                    renderPage={(pageData, pageId, layout) => {
                    }}
                    pageDataArray={['Account', 'Profile', 'Band', 'Membership', 'Dashboard']}
                    onPageSelected={page => {
                        this.setState({currentPage: page.position})
                    }}
                />*/}

                <View style={{flex: 1}}>

                    <View style={{flex: 1}}>
                        <FlatList
                            ref={(ref) => {
                                this.list = ref;
                            }}
                            onScroll={(e) => this.handleScroll(e)}
                            //      numColumns={3}
                            //       data={this.pageDataArray1}
                            data={this.selectListInFlatlist(this.state.currentPage)}
                            // data={this.selectListInFlatlist(this.state.currentPage)}
                            keyExtractor={(item, index) => item.svg}
                            renderItem={({item, index}) => {
                                return <HMItemCategory
                                    selectTick={container.selectTick}
                                    currentPage={this.state.currentPage}
                                    item={item} index={index}
                                    onPress={
                                        () => container.goNext(item, index)
                                    }/>
                            }

                            }
                        />
                        {
                            this.state.currentPage != 4 ?
                                null
                                :
                                <View
                                    style={{
                                        position: 'absolute',
                                        flex: 1,
                                        // height:'100%',
                                        // alignContent: 'center',
                                        // alignItems: 'center',
                                        //  justifyContent: 'center',

                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        backgroundColor: 'rgba(0,0,0,0.01)',
                                        zIndex: 999
                                    }}>


                                    <HMTextInput
                                        value={this.state.description}
                                        _multiline
                                        onChangeText={text => {
                                            this.setState({description: text})
                                        }}
                                        autoFocus
                                        styleInput={{height: moderateScale(80)}}
                                        //   keyboardType="numeric"
                                        placeholder={i18n.t('constant.PlaceholderDesc')}
                                        style={{
                                            // width: "90%",
                                            // height:moderateScale(100),
                                            fontSize: moderateScale(14)
                                        }} underlineColorAndroid="transparent"
                                        containerStyle={{
                                            //marginHorizontal: moderateScale(8),
                                            borderWidth: 1,
                                            borderRadius: 2,
                                            borderColor: '#ddd',
                                            borderBottomWidth: 0,
                                            shadowColor: '#000',
                                            shadowOffset: {width: 0, height: 2},
                                            shadowOpacity: 0.8,
                                            shadowRadius: 2,
                                            elevation: 1,
                                            marginLeft: 5,
                                            marginRight: 5,
                                            marginTop: moderateScale(5),
                                        }}
                                        textCenter={'center'}
                                    />
                                    <View style={{flex: 1, flexDirection: "row"}}>
                                        <TouchableOpacity
                                            onPress={() => this.setState({

                                                //     address: !this.state.checked ? "من در رستوران غذا را تحویل میگیرم" : this.props.user.address,
                                                checkedStatus: !this.state.checkedStatus,
                                            })}

                                            style={{
                                                flexDirection: "row",
                                                // alignSelf: "flex-end",
                                                marginHorizontal: moderateScale(6),
                                                marginVertical: moderateScale(8)
                                            }}>
                                            <View style={{
                                                width: moderateScale(24),
                                                height: moderateScale(24),
                                                backgroundColor: '#ffffff',
                                                borderRadius: moderateScale(12),
                                                alignItems: 'center', justifyContent: 'center',
                                                borderWidth: moderateScale(1),
                                                borderColor: Colors.gray

                                            }}>
                                                <Image
                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                    source={(PathFile.image.Check)}
                                                    //resizeMode="stretch"
                                                    style={[!this.state.checkedStatus ? {
                                                        width: moderateScale(0),
                                                        height: moderateScale(0),
                                                    } : {


                                                        width: moderateScale(18),
                                                        height: moderateScale(18),
                                                    }]}/>
                                            </View>

                                            <View style={{width: moderateScale(8)}}/>
                                            <View
                                            >
                                                <HMTextView
                                                    //text="اطلاعاتم بصورت محرمانه باشد"
                                                    text={"تغییر وضعیت به ثبت شد"}
                                                    style={{color: !this.state.checkedStatus ? Colors.colorDark : Colors.green}}
                                                />

                                            </View>

                                        </TouchableOpacity>
                                        <View style={{width: moderateScale(8)}}/>
                                        <TouchableOpacity
                                            onPress={() => this.setState({

                                                //     address: !this.state.checked ? "من در رستوران غذا را تحویل میگیرم" : this.props.user.address,
                                                checkedIcon: !this.state.checkedIcon,
                                            })}

                                            style={{
                                                flexDirection: "row",
                                                // alignSelf: "flex-end",
                                                marginHorizontal: moderateScale(6),
                                                marginVertical: moderateScale(8)
                                            }}>
                                            <View style={{
                                                width: moderateScale(24),
                                                height: moderateScale(24),
                                                backgroundColor: '#ffffff',
                                                borderRadius: moderateScale(12),
                                                alignItems: 'center', justifyContent: 'center',
                                                borderWidth: moderateScale(1),
                                                borderColor: Colors.gray

                                            }}>
                                                <Image
                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                    source={(PathFile.image.Check)}
                                                    //resizeMode="stretch"
                                                    style={[!this.state.checkedIcon ? {
                                                        width: moderateScale(0),
                                                        height: moderateScale(0),
                                                    } : {


                                                        width: moderateScale(18),
                                                        height: moderateScale(18),
                                                    }]}/>
                                            </View>
                                            <View style={{width: moderateScale(8)}}/>
                                            <View
                                            >
                                                <HMTextView
                                                    //text="اطلاعاتم بصورت محرمانه باشد"
                                                    text={"تغییر آیکون"}
                                                    style={{color: !this.state.checkedIcon ? Colors.colorDark : Colors.green}}
                                                />

                                            </View>

                                        </TouchableOpacity>
                                    </View>
                                </View>
                        }


                    </View>
                    {/* <ViewPager
                        ref='viewPager'
                        style={{flex: 1, backgroundColor: 'white'}}
                        renderPage={this.renderPage.bind(this)}
                        pageDataArray={this.pageDataArray}
                        initialPage={0}
                        pageMargin={20}
                        scrollEnabled={true}
                        onPageScroll={(e) => {
                        }}
                        onPageScrollStateChanged={(state) => {
                        }}
                        onPageSelected={(page) => {
                            this.setState({currentPage: page})

                        }}

                    />*/}
                    <View
                        style={{
                            width: '100%',
                            height: moderateScale(42),
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: moderateScale(8)
                        }}>
                        {


                            <View
                                style={{
                                    width: '100%',
                                    height: moderateScale(42),
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: moderateScale(8)
                                }}
                            >
                                <TouchableOpacity
                                    onPress={() => {
                                        // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                        //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                        this.goBack();
                                    }}
                                    style={{
                                        flex: .48,
                                        height: moderateScale(42),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.colorPrimary,
                                        borderRadius: moderateScale(6)

                                    }}>

                                    <HMTextView
                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={i18n.t('constant.Back')} type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(6),
                                            marginHorizontal: moderateScale(4),
                                            color: Colors.white
                                        }}/>
                                </TouchableOpacity>

                                <View style={{width: moderateScale(8)}}/>
                                <TouchableOpacity

                                    onPress={() => {
                                        //   this.refs['viewPager'].setPage(this.state.currentPage + 1);
                                        if (this.state.currentPage <= 3) {
                                            // indexSelectedArray1: -1,
                                            //     itemSelectedArray1: null,
                                            //
                                            //     itemSelectedArray1Sub: null,
                                            //     indexSelectedArray1Sub: -1,
                                            //
                                            //     indexSelectedArray2: -1,
                                            //     itemSelectedArray2: null,
                                            //
                                            //
                                            //     indexSelectedArray2Sub: -1,
                                            //     itemSelectedArray2Sub: null,

                                            if (this.state.currentPage == 0 && this.state.indexSelectedArray1 == -1)
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            else if (this.state.currentPage == 1 && this.state.indexSelectedArray1Sub == -1) {
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            } else if (this.state.currentPage == 2 && this.state.indexSelectedArray2 == -1) {
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            } else if (this.state.currentPage == 3 && this.state.indexSelectedArray2Sub == -1) {
                                                HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )
                                            } else
                                                this.setState({
                                                        typeButton: "next",
                                                        currentPage: this.state.currentPage + 1
                                                    }
                                                    , () => {

                                                    }
                                                )
                                        } else {


                                            this.setData()
                                        }


                                    }}
                                    style={{
                                        flex: .48,
                                        height: moderateScale(42),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.colorPrimary,
                                        borderRadius: moderateScale(6)
                                    }}>
                                    <HMTextView
                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={textButtonNext} type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(6),
                                            marginHorizontal: moderateScale(4),
                                            color: Colors.white
                                        }}/>
                                </TouchableOpacity>
                            </View>

                        }


                    </View>
                </View>
                {
                    this.props.NoInternetDialog ?
                        <DialogConnectionCustomize
                            onPress={() => this.setData()}
                        />
                        :
                        null
                }
                {
                    this.props.isLoading || this.props.isLoadingSet ?
                        <DialogLoadingCustomize
                        />
                        : null
                }
            </View>
        )
    }

    goNext(item, index) {
        /*     let arr=this.CheckListInFlatlist(this.state.currentPage + 1,index);
                                                if(arr&&arr.length>0){*/
        let selectItem = "selectItem_" + index
        let selectIndex = "selectIndex_" + index

        //   let nameState= I

        switch (container.state.currentPage) {
            case 0:


                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1: index,
                        itemSelectedArray1: item,

                        itemSelectedArray1Sub: null,
                        indexSelectedArray1Sub: -1,
                        // itemSelectedArray1Sub: item.subjects[0],
                        // indexSelectedArray1Sub: 0,
                        typeButton: "next",
                        currentPage: container.state.currentPage + 1
                        //pageDataArray1Sub:container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {
                        setTimeout(function () {
                            //  container.setState({timePassed: true})

                            try {
                                container.list.scrollToIndex({
                                    animated: true,
                                    index: Platform.OS === 'android' ? 0 : 0
                                })

                            } catch (e) {

                            }

                        }, 400)
                        //  container.list.scrollToIndex({animated: true, index: 0})
                        //   container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;

            case 1:
                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1Sub: index,
                        itemSelectedArray1Sub: item,
                        typeButton: "next"
                        //  pageDataArray1Sub:container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;
            case 2:
                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray2: index,
                        itemSelectedArray2: item,

                        //   itemSelectedArray2Sub: item.subplaces[0],
                        // indexSelectedArray2Sub: 0,

                        itemSelectedArray2Sub: null,
                        indexSelectedArray2Sub: -1,
                        typeButton: "next"
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;

            case 3:
                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray2Sub: index,
                        itemSelectedArray2Sub: item,
                        typeButton: "next"
                        //pageDataArray1Sub: container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;
        }
        /*    }
            else {
                container.setState({currentPage: container.state.currentPage + 2})
            }
    */

        /* NavigationService.navigateParams((item.types && item.types.length > 0) ? "ChildChildSubCategoryScreen" : "PrivatizationsScreen", {
             id: item.id,
             ItemsSelect: {
                 item_Category: props.ItemsSelect.item_Category,
                 item_SubCategory: props.ItemsSelect.item_SubCategory,
                 item_ChildSubCategory: item
             }
         })*/

    }

    selectListInFlatlist(index) {
        let d = null
        switch (index) {
            case 0:
                d = this.pageDataArray1

                this.nextEmpty(d, this.state.indexSelectedArray1)

                return d

            case 1:
                //d = [];
                d = this.pageDataArray1?.[this.state.indexSelectedArray1]?.units
                this.nextEmpty(d, this.state.indexSelectedArray1Sub)
                return d

            case 2:
                //  d = this.pageDataArray2
                // d = [];
                d = this.pageDataArray1?.[this.state.indexSelectedArray1]?.units[this.state.indexSelectedArray1Sub]?.units
                this.nextEmpty(d, this.state.indexSelectedArray2)
                return d


            case 3:
                d = [];
                if (this.state.indexSelectedArray2 != -1)
                    d = this.pageDataArray1?.[this.state.indexSelectedArray1]?.units[this.state.indexSelectedArray1Sub]?.units[this.state.indexSelectedArray2]?.units

                // d = [];
                // d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                this.nextEmpty(d, this.state.indexSelectedArray2Sub)
                return d


        }
    }

    goToIndex(index) {
        setTimeout(function () {
            //  this.setState({timePassed: true})
            //  if (index > 6)
            try {
                container.list.scrollToIndex({animated: true, index: index});

            } catch (e) {

            }
        }, 400)
        /*    setTimeout(function(){

                //Put All Your Code Here, Which You Want To Execute After Some Delay Time.
                HMAlert("Alert Shows After 5 Seconds of Delay.")

            }, 1000);*/
    }

    nextEmpty(data, index) {

        if (data && data.length > 0) {

            this.goToIndex(index)
        } else {
            this.setState({
                    currentPage: this.state.typeButton === "next" ? this.state.currentPage + 1 : this.state.currentPage - 1
                },
                () => {

                })
        }

    }

    CheckListInFlatlist(page, index) {
        switch (page) {
            case 0:

                return this.pageDataArray1;

            case 1:
                return this.pageDataArray1[index].units;

            case 2:
                // return this.pageDataArray2
                return this.pageDataArray1[this.state.indexSelectedArray1].units[index].units;


            case 3:

                // return this.pageDataArray2[index].subplaces
                return this.pageDataArray1[this.state.indexSelectedArray1].units[this.state.indexSelectedArray1Sub].units[index].units;


        }
    }

    selectTick(index) {
        switch (container.state.currentPage) {
            case 0:

                return container.state.indexSelectedArray1 == index

            case 1:

                return container.state.indexSelectedArray1Sub == index
            case 2:

                return container.state.indexSelectedArray2 == index

            case 3:


                return container.state.indexSelectedArray2Sub == index

        }
    }


}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#ffffff'
    },
    stepIndicator: {
        marginVertical: moderateScale(6)
    },
    page: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    }
});
